import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Button, Icon } from "antd";
import { ReactComponent as EmptyMessagesSvg } from "../../assets/icon/ic_message_24dp.svg";
import { ReactComponent as ErrorMessageSvg } from "../../assets/icon/ic_warning_24dp.svg";
import { ReactComponent as EmptySearchSvg } from "../../assets/icon/ic_search_24dp.svg";
import "./SystemMessages.scss";

function EmptyMessage({ createChat, formatMessage }) {
  return (
    <div className="empty-message-container">
      <EmptyMessagesSvg
        className="empty-message"
        alt="Não foram encontradas mensagens"
      />

      <span className="empty-message-header">
        {formatMessage({ id: "message.empty" })}
      </span>
      <span className="empty-message-description">
        {formatMessage({ id: "message.empty.description" })}
      </span>
      <Button onClick={() => createChat()}>
        {formatMessage({ id: "chat.newMessage" })}
      </Button>
    </div>
  );
}

function ErrorMessage({ formatMessage, secondsRemaining }) {
  return (
    <div className="empty-message-container error">
      <ErrorMessageSvg
        className="empty-message error"
        alt="Não foram encontradas mensagens"
      />

      <span className="empty-message-header">
        {formatMessage({ id: "message.error" })}
      </span>
      <span className="empty-message-description">
        {formatMessage({ id: "message.error.description" })}
      </span>

      <span>
        {" "}
        {secondsRemaining > 0
          ? formatMessage(
              { id: "error.reconnectingIn" },
              { seconds: secondsRemaining }
            )
          : formatMessage({ id: "error.reconnecting" })}
      </span>
    </div>
  );
}

function ReconnectMessage({ formatMessage, secondsRemaining }) {
  return (
    <div className="empty-message-container">
      <Icon className="loading" type="loading" />

      <span>
        {" "}
        {secondsRemaining > 0
          ? formatMessage(
              { id: "error.reconnectingIn" },
              { seconds: secondsRemaining }
            )
          : formatMessage({ id: "error.reconnecting" })}
      </span>
    </div>
  );
}

function EmptySearchMessage({ resetFilters, formatMessage }) {
  return (
    <div className="empty-message-container">
      <EmptySearchSvg
        className="empty-message"
        alt="Não foram encontradas mensagens"
      />

      <span className="empty-message-header">
        {formatMessage({ id: "message.noResults" })}
      </span>
      <span className="empty-message-description">
        {formatMessage({ id: "message.noResults.description" })}
      </span>
      <Button onClick={resetFilters}>
        {formatMessage({ id: "filter.clearFilters" })}
      </Button>
    </div>
  );
}

class SystemMessages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsRemaining: 15,
      tries: 0,
    };
    this.interval = null;
    this.reconnectSecondsTick = this.reconnectSecondsTick.bind(this);
  }

  componentDidMount() {
    if (this.props.hasErrors) {
      this.startInterval();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.hasErrors && !this.props.hasErrors) {
      clearInterval(this.interval);
    }
    if (!prevProps.hasErrors && this.props.hasErrors) {
      this.startInterval();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  startInterval() {
    this.interval = setInterval(this.reconnectSecondsTick, 1000);
  }

  reconnectSecondsTick() {
    this.setState({
      secondsRemaining: this.state.secondsRemaining - 1,
    });
    if (this.state.secondsRemaining === 0) {
      this.props.hasErrors && this.props.reconnect();
    }
    if (this.state.secondsRemaining === -5) {
      this.setState({
        secondsRemaining: 15,
        tries: this.state.tries + 1,
      });
    }
  }

  getEmptyMessage() {
    const {
      loading,
      hasErrors,
      listLength,
      isSearching,
      resetFilters,
      createChat,
    } = this.props;
    const { formatMessage } = this.props.intl;

    if (hasErrors) {
      if (this.state.tries > 5) {
        return (
          <ErrorMessage
            formatMessage={formatMessage}
            secondsRemaining={this.state.secondsRemaining}
          />
        );
      } else {
        return (
          <ReconnectMessage
            formatMessage={formatMessage}
            secondsRemaining={this.state.secondsRemaining}
          />
        );
      }
    }

    if (listLength > 0 || loading) return false;

    if (isSearching) {
      return (
        <EmptySearchMessage
          resetFilters={resetFilters}
          formatMessage={formatMessage}
        />
      );
    }

    return (
      <EmptyMessage createChat={createChat} formatMessage={formatMessage} />
    );
  }

  render() {
    return <div className="system-messages">{this.getEmptyMessage()}</div>;
  }
}

export default injectIntl(SystemMessages);
